import { FileCopyOutlined, Info } from "@mui/icons-material";
import { Box, FormHelperText, Grid, TextField, Tooltip, Typography } from "@mui/material";
import { HStack, VStack } from "Components/Layouts";
interface IExtractedContext {
  filename: string;
  meta: string;
  similarity: number;
  text: string;
}
interface IChoice {
  index: number;
  message: {
    content: string;
    role: string;
  };
}
interface IPrediction {
  choices: IChoice[];
  usage: {
    completion_tokens: number;
    prompt_tokens: number;
    total_tokens: number;
  };
}

interface IProps {
  addOns: {
    project?: string;
    messengerCallbacks?: {
      setChatbot: () => void;
      regenSession: () => void;
      restartChat: () => void;
      welcomeMessage: () => void;
      onSendAppend: () => void;
    };
    payload: {
      prediction: IPrediction;
      extracted_context: string;
      context_ranks: IExtractedContext[];
    };
  };
}

function ContextsDetails({ contexts }: { contexts?: IExtractedContext[] }) {
  if (!contexts) return <></>;
  const round2Decimal = (num: number) => {
    return Math.round((num + Number.EPSILON) * 100) / 100;
  };
  return (
    <VStack height={"100%"} width={"100%"} className="contexts-details" justifyContent={"flex-start"}>
      <Typography color={"primary.main"}>{`Top Context Ranks`}</Typography>

      {contexts.map((context, index) => {
        return (
          <Grid
            container
            key={index}
            className="context-details"
            p={1}
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            {/* <TextField label="Filename" value={context.filename} /> */}

            {/* <TextField label="Meta" value={context.meta} /> */}
            <Grid item xs={2} component={VStack}>
              <Typography>{round2Decimal(context.similarity)}</Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField multiline fullWidth value={context.text} />
            </Grid>
            <Grid item xs={1} component={HStack}>
              <Tooltip title={context.filename}>
                <Info color="info" />
              </Tooltip>
            </Grid>
          </Grid>
        );
      })}
    </VStack>
  );
}

function PredictionDetails({ prediction }: { prediction?: IPrediction }) {
  if (!prediction) return <></>;
  return (
    <Grid
      container
      className="prediction-details"
      p={1}
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
      }}
    >
      <Grid item xs={12}>
        <Typography>{`Total Tokens: ${prediction.usage.total_tokens}`}</Typography>
      </Grid>
    </Grid>
  );
}

export function Talk2GPTDetails({ addOns }: IProps) {
  const { messengerCallbacks, payload } = addOns;
  const prediction = payload?.prediction;
  const contexts = payload?.context_ranks;
  const extractedContext = payload?.extracted_context;

  return (
    <VStack width={"100%"} className="talk2gpt-details" height={"100%"} overflow={"scroll"} justifyContent="flex-start" p={1}>
      <Typography variant="h6" color={"primary.main"}>
        {"Prediction Details"}
      </Typography>

      <Typography color={"primary.main"}>{`Extracted Context`}</Typography>
      <TextField value={extractedContext} fullWidth multiline />

      <HStack>
        <ContextsDetails contexts={contexts} />
      </HStack>
      <PredictionDetails prediction={prediction} />
    </VStack>
  );
}
